import { z } from 'zod';

export const timeseriesItemSchema = z.object({
  date: z.string(),
  activations: z.number().int(),
  licenses: z.number().int(),
});

export const dashboardStatsSchema = z.object({
  total: z.number().int(),
  active: z.number().int(),
  expired: z.number().int(),
  revoked: z.number().int(),
  pending: z.number().int(),
  grace: z.number().int(),
  activationsTotal: z.number().int(),
  activationsLast30Days: z.number().int(),
  last30Days: z.array(timeseriesItemSchema).optional(),
});

export const alertItemSchema = z.object({
  id: z.string().uuid(),
  serial: z.string(),
  alertType: z.enum(['grace_period', 'expired', 'revoked']),
  expiresAt: z.string().nullable(),
  daysSinceExpiry: z.number().int(),
});

export const dashboardAlertsSchema = z.object({
  data: z.array(alertItemSchema),
  total: z.number().int(),
});

export const activationItemSchema = z.object({
  id: z.string(),
  licenseId: z.string(),
  serial: z.string(),
  fingerprintHash: z.string(),
  installationId: z.string().nullable(),
  activatedAt: z.string(),
  lastSeen: z.string().nullable(),
  deactivatedAt: z.string().nullable(),
});

export const dashboardActivationsSchema = z.object({
  data: z.array(activationItemSchema),
  total: z.number().int(),
  page: z.number().int(),
  limit: z.number().int(),
  pages: z.number().int(),
});

export const auditItemSchema = z.object({
  id: z.string(),
  licenseId: z.string(),
  serial: z.string(),
  event: z.string(),
  performedBy: z.string(),
  timestamp: z.string(),
});

export const licensesAuditSchema = z.object({
  data: z.array(auditItemSchema),
  total: z.number().int(),
});

// ── Device Inventory (License Details → Devices tab) ───────────────────────

export const deviceDiskSchema = z.object({
  model: z.string().optional(),
  serial: z.string().optional(),
  sizeBytes: z.number().int().optional(),
});

export const deviceServoSchema = z.object({
  model: z.string().optional(),
  serial: z.string().optional(),
  position: z.string().optional(),
});

export const deviceDriveSchema = z.object({
  axis: z.number().optional(),
  model: z.string().optional(),
  firmware: z.string().optional(),
  userId: z.string().optional(),
  userIdSet: z.boolean().optional(),
  configHash: z.string().optional(),
  calibrated: z.boolean().optional(),
  driver: z.string().optional(),
  serial: z.string().optional(),
  available: z.boolean().optional(),
});

export const deviceModuleSchema = z.object({
  name: z.string().optional(),
  version: z.string().optional(),
});

export const deviceInventoryItemSchema = z.object({
  pcModel: z.string().nullable(),
  ramBytes: z.number().nullable(),
  os: z.string().nullable(),
  disks: z.array(deviceDiskSchema),
  servos: z.array(deviceServoSchema),
  modules: z.array(deviceModuleSchema),
  drives: z.array(deviceDriveSchema),
  robotConfig: z.record(z.unknown()).nullable(),
  rawFingerprint: z.record(z.unknown()).nullable(),
  reportedAt: z.string().nullable(),
});

export const deviceActivationItemSchema = z.object({
  id: z.string(),
  licenseId: z.string(),
  fingerprintHash: z.string(),
  installationId: z.string().nullable(),
  activatedAt: z.string(),
  lastSeen: z.string().nullable(),
  deactivatedAt: z.string().nullable(),
  device: deviceInventoryItemSchema.nullable(),
});

export const licenseDevicesSchema = z.object({
  data: z.array(deviceActivationItemSchema),
});
